import TabletAndroidOutlinedIcon from "@mui/icons-material/TabletAndroidOutlined";
import Box from "@mui/material/Box";
import { kioskStaffApi } from "@bw/shared/api";
import type { KioskDevice, KioskMode } from "@bw/shared/types/generated";
import { useEffect, useState } from "react";

import { kioskToolbarStatus } from "./kiosk-display";

/** "Kiosk · Entrance · online" at the start of the Front desk toolbar (#2691). */
export function KioskStatusChip({
  facilityId,
  devices,
  loading,
}: {
  facilityId: string;
  devices: readonly KioskDevice[];
  loading: boolean;
}) {
  const [mode, setMode] = useState<KioskMode | null>(null);

  useEffect(() => {
    let cancelled = false;
    kioskStaffApi
      .getSettings(facilityId)
      .then((settings) => {
        if (!cancelled) setMode(settings.mode);
      })
      .catch(() => {
        // The device list still says whether a kiosk is online.
      });
    return () => {
      cancelled = true;
    };
  }, [facilityId]);

  if (loading) return null;
  const status = kioskToolbarStatus(mode, devices);
  const online = status.tone === "online";
  return (
    <Box
      role="status"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.75,
        height: 32,
        px: 1.25,
        borderRadius: 1,
        typography: "body2",
        fontWeight: 600,
        whiteSpace: "nowrap",
        color: online ? "primary.main" : "text.secondary",
        bgcolor: online ? "action.selected" : "action.hover",
      }}
    >
      <TabletAndroidOutlinedIcon sx={{ fontSize: 18 }} />
      {status.label}
    </Box>
  );
}
